/**
 * @description Authentication Store Module
 * @author Fahid Mohammad
 */

import http from '../../util/axios'
const VueCookie = require('vue-cookie') // using require to avoid SSR rejection

export default {
    namespaced: true,
    state: {
        isLoggedIn:false,
        isLoading:false,
        token:""
    },
    mutations:{
        addLogin: (state, {status, token}) => {
            state.isLoggedIn = status
            state.token = token
        },
        setLoading: (state, status) => {
            state.isLoading = status
        }
    },
    actions:{
        LOGIN_REQUEST({ commit }, form) {
            commit('setLoading', true)
            return http.post("/employee/login", form).then(response => {
                commit('setLoading', false)
                let status = false, token = null;
                if(response.status===1000){
                    status = true; token = response.token;
                    //  Commit to store
                    commit('addLogin', { status, token })
                    //  Set cookie
                    VueCookie.set('token',token);
                    localStorage.setItem('fnids',JSON.stringify(response.f));
                    localStorage.setItem('userdetails',JSON.stringify(response.userdata))
                  /*   VueCookie.set('userdetails',JSON.stringify(response.userdata)); */
                    localStorage.setItem('eventids',JSON.stringify(response.e));
                    localStorage.setItem('menu',JSON.stringify(response.menuList));
                    return response
                }else{
                    return {status:response.status, message:response}
                }
            })
        },
        CHANGEPASSWORD_REQUEST({ commit }, form) {
          
            return http.post("/employee/changePassword", form).then(response => {
                let _self = this;
                if(response.status===1000){
                    return {status: true, message: response.message}
                }else{
                    return {status: false, message:response.error};
                }
            })
        },
        UPDATE_LOGIN({ commit }, {status, token}) {
            commit('addLogin', { status, token })
        },
        LOGOUT({commit}){
            return new Promise((resolve, reject) => {
                VueCookie.delete('token');
                let status = false, token = null;
                localStorage.clear();
                commit('addLogin', { status, token })
                setTimeout(function(){ // to avoid glitch in SSR router push
                    resolve(true)
                },200)
            })
        },
    },
    getters:{
        getLoginStatus: state => {
            return state.isLoggedIn
        },
        getToken : state =>{
            return state.token
        },
    }
}
    



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js